module.exports = __webpack_public_path__ + "static/media/gitee-logo.567691af.svg";